// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"93ead144","447":"9282ede5","774":"f49ddc58","793":"34ccdd50"}[chunkId] + ".chunk.css";
};